// extracted by mini-css-extract-plugin
export default {"container":"TileTimeValue_container__JXM2C","valueUnit":"TileTimeValue_valueUnit__foT4K","value":"TileTimeValue_value__-4A+x","unit":"TileTimeValue_unit__ttXWR"};